import gql from 'graphql-tag';
import { categoryFieldsFragment } from './categoryFieldsFragment';
import { evaluationFieldsFragment } from './evaluationFieldsFragment';
import { sanityDocumentFieldsFragment } from './sanityDocumentFieldsFragment';
import { ownerFieldsFragment } from './ownerFieldsFragment';

export const sessionFieldsFragment = gql`
  fragment AdminSessionFields on Session {
    ... on SanityDocument {
      ...AdminSanityDocumentFields
    }
    owner {
      ...AdminOwnerFields
    }
    name
    referenceFormat
    passPercentage
    categories {
      _ref
    }
    evaluations {
      _ref
    }
    rCategories {
      ...AdminCategoryFields
    }
    rEvaluations {
      ...AdminEvaluationFields
    }
    archived
  }

  ${sanityDocumentFieldsFragment}
  ${ownerFieldsFragment}
  ${categoryFieldsFragment}
  ${evaluationFieldsFragment}
`;
